import { render, staticRenderFns } from "./PersonalOverviewRelation.vue?vue&type=template&id=6e69711b&scoped=true&"
import script from "./PersonalOverviewRelation.vue?vue&type=script&lang=js&"
export * from "./PersonalOverviewRelation.vue?vue&type=script&lang=js&"
import style0 from "./PersonalOverviewRelation.vue?vue&type=style&index=0&id=6e69711b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e69711b",
  null
  
)

export default component.exports